import { getAge } from "../utils/date";

const useEmail = (props) => {

    const arrangeEmailContent = (emailContent) => {
        const sp = emailContent?.["suggestions"] || emailContent?.["suggested_programs"];

        let content = "";
        content += `Email Subject: ${emailContent?.email_subject}\n\n`;
        content += `Email Preview Text: ${emailContent?.email_preview_text}\n\n`;
        content += `Headline 1: ${emailContent?.headline_1}\n\n`;
        content += `Subtext 1: ${emailContent?.subtext_1}\n\n`;
        content += `Headline 2: ${emailContent?.headline_2}\n\n`;
        content += `Subtext 2: ${emailContent?.subtext_2}\n\n`;
        content += `Headline 3: ${emailContent?.headline_3}\n\n`;
        content += `Suggested Programs: \n`;
        for (let i = 0; i < sp.length; i++) {
            content += `    ${sp[i]?.program_name}\n\n`;
            content += `    ${sp[i]?.program_description}\n\n`;
        }
        content += `\nSubtext 3: ${emailContent?.subtext_3}\n\n`;
        content += `Sign Off: ${emailContent?.sign_off}\n\n`;

        return content;
    }

    return {
        arrangeEmailContent,
    };
};

export default useEmail;
